// Carlorbiz prose styling — Landing-aesthetic markdown rendering.
// Imported by CardGridPage, TabDetail, TabContentRenderer, and any other
// component that renders markdown content. Kept here (not in components/) so
// it lifts cleanly into the nera-pwa-template repo without dragging
// Carlorbiz-specific component code.

export const CARLORBIZ_PROSE = [
  'prose prose-lg max-w-none font-body',
  'prose-headings:font-heading prose-headings:font-extrabold prose-headings:tracking-tight',
  'prose-h2:text-2xl md:prose-h2:text-3xl prose-h2:text-[#2D7E32] prose-h2:mt-8 prose-h2:mb-3',
  'prose-h3:text-xl md:prose-h3:text-2xl prose-h3:text-[#2D7E32] prose-h3:mt-6 prose-h3:mb-2',
  'prose-h4:text-lg prose-h4:text-[#2E4A3A] prose-h4:font-bold prose-h4:mt-5 prose-h4:mb-2',
  'prose-p:text-[#2E4A3A] prose-p:leading-relaxed prose-p:my-4',
  'prose-strong:text-[#2D7E32] prose-strong:font-bold',
  'prose-em:text-[#2E4A3A]',
  'prose-a:text-[#D5B13A] prose-a:font-semibold prose-a:underline prose-a:underline-offset-4 prose-a:decoration-[#D5B13A]/40 hover:prose-a:text-[#2D7E32] hover:prose-a:decoration-[#2D7E32]',
  'prose-ul:my-4 prose-ul:pl-5 prose-li:my-1.5 prose-li:text-[#2E4A3A]',
  'prose-ol:my-4 prose-ol:pl-5',
  'marker:text-[#D5B13A]',
  'prose-blockquote:border-l-4 prose-blockquote:border-[#2D7E32] prose-blockquote:pl-6 prose-blockquote:py-2',
  'prose-blockquote:bg-[#F9F9F9] prose-blockquote:text-xl prose-blockquote:text-[#2E4A3A] prose-blockquote:font-bold prose-blockquote:not-italic',
  'prose-hr:border-0 prose-hr:h-px prose-hr:my-8 prose-hr:bg-gradient-to-r prose-hr:from-transparent prose-hr:via-[#D5B13A]/60 prose-hr:to-transparent',
  'prose-code:text-[#2D7E32] prose-code:bg-[#F9F9F9] prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:before:content-none prose-code:after:content-none prose-code:font-mono prose-code:text-sm',
].join(' ');
